import composeInstallation from '../utils/composeInstallation'

const install = composeInstallation({
  name: 'stripe',
  scriptId: 'stripe-js',
  makeScriptUri: () => 'https://js.stripe.com/v3/'
})

export { install }
